import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import dateFormatter from '@/locales/date-formatter';

// Import translation files
import enUS from '@/locales/en-US.json';
import enAU from '@/locales/en-AU.json';
import enGB from '@/locales/en-GB.json';

const resources = {
  'en-US': {
    translation: enUS,
  },
  'en-AU': {
    translation: enAU,
  },
  'en-GB': {
    translation: enGB,
  },
};

// Determine language based on NEXT_PUBLIC_SB_REGION environment variable
const getLanguageFromRegion = () => {
  const region = process.env.NEXT_PUBLIC_SB_REGION;
  if (!region) return 'en-AU';
  
  switch (region) {
    case 'nova': return 'en-US';
    case 'aus': return 'en-AU';
    case 'lon': return 'en-GB';
    default: return 'en-AU';
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getLanguageFromRegion(),
    fallbackLng: 'en-AU',
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false, // React already escapes values
      format: dateFormatter,
    },

    react: {
      useSuspense: false, // Prevents hydration issues in Next.js
    },
  })
  .catch((error) => {
    console.error('Failed to initialize i18n:', error);
  });

export default i18n; 